import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { OutputDataUrl } from './OutputDataUrl';
import { OutputTestCalculationType } from '../schema/types';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { OutputTestValidationSchema } from '../schema/OutputTestValidationSchema';

export const getTestValidation = (dagRunId: string) =>
  apiClient
    .get<OutputTestCalculationType>(
      expand(OutputDataUrl.TEST_VALIDATIONS, { dagRunId }),
    )
    .then((response) => OutputTestValidationSchema.parse(response.data));

export const useTestValidateQuery = createApiQueryHook(
  ['outputTestValidations'],
  getTestValidation,
);
